import React from 'react';
import { state, Beep } from 'react-beep';
import logo from 'assets/images/logoEn.svg';
import { withRouter } from 'react-router-dom';
import Routes from 'configs/routes';
import Button from 'microcomponents/button';
import Input from 'microcomponents/input';
import { Link } from 'react-router-dom';
import { convertFaNumToArNum } from 'utils/convert-num';
import services from 'services';
import styles from './style';
import Typography from 'microcomponents/typography';
import userRoles from 'utils/userRoles';
import centralInsuranceImage from '../../assets/images/markazi.webp';
import centralLicenseImage from '../../assets/images/central-license-image.webp';

import { ToasterNotify } from 'utils/toaster';

class Footer extends Beep(['user']) {
  state = {
    isShowMenu: false,
    tel: '',
    email: '',
  };
  handleShowMenu = () => {
    this.setState((prevState) => {
      return { isShowMenu: !prevState.isShowMenu };
    });
  };

  handleChangeInput = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handelTel = async () => {
    const { tel } = this.state;
    const mobile = convertFaNumToArNum(tel);
    let val = mobile;
    const telReg = new RegExp('^[0][9][0-9][0-9]{8,8}$');
    if (telReg.test(val)) {
      let model = { phone: val };
      const data = await services.user.telephone(model);
      if (data.succeeded === true) {
        ToasterNotify('تلفن شما با موفقیت ثبت شد', 'success');
      }
    } else {
      ToasterNotify('تلفن خود را درست وارد کنید');
    }
  };

  handelEmail = async () => {
    const { email } = this.state;
    let val = email;
    const emailReg = new RegExp(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    );
    if (emailReg.test(val)) {
      let model = { email: val };
      const data = await services.user.khabarname(model);
      if (data.succeeded === true) {
        ToasterNotify('ایمیل شما با موفقیت ثبت شد', 'success');
      }
    } else {
      ToasterNotify('ایمیل خود را درست وارد کنید');
    }
  };

  handelClickSamandehi = () => {
    window.open(
      'https://logo.samandehi.ir/Verify.aspx?id=167019&p=rfthgvkajyoeobpdrfthpfvl',
      'Popup',
      'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30'
    );
  };

  handelClickCentralInsurance = () => {
    window.open(centralLicenseImage);
  };

  render() {
    const { tel, email } = this.state;
    const { classes } = this.props;
    const route = Routes.find(
      (route) =>
        route.path === this.props.location.pathname ||
        route.path === '/company/:id' ||
        route.path === '/company/:id/report'
    );
    return (
      route &&
      route.appBar && (
        <>
          {this.props.location.pathname === '/landing/naft' ||
          userRoles('hidden logo') ? (
            <div style={{ height: 100 }} />
          ) : null}

          <footer
            className={
              this.props.location.pathname === '/landing/naft' ||
              userRoles('hidden logo')
                ? 'hidden-compelete'
                : ''
            }
          >
            <section className="about-us">
              <div className="container-fluid">
                <div className="row justify-content-center ">
                  <div className="col-md-11">
                    <div className="row align-items-start">
                      <div className="col-md-4">
                        <div className="rahnama-phone">
                          <i className="icon-headphones"> </i>
                          <div className="text-phone">
                            <span> مرکز تماس: </span>
                            <span>021-91005110</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="rahnama-email">
                          <i className="icon-email"> </i>
                          <div className="text-mail">
                            <span> ایمیل: </span>
                            <span> info@bimebama.com </span>
                          </div>
                        </div>
                        <div className="support-form">
                          <Link to={'/advice'}>
                            فرم پشتیبانی
                            <i className="icon-left-arrow"> </i>
                          </Link>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="consultation">
                          <i className="icon-coffee-cup"> </i>
                          <div className="text-mail">
                            <span>
                              {' '}
                              از طریق فرم آنلاین هم می‌توانید مشاوره رایگان
                              بگیرید{' '}
                            </span>
                          </div>
                        </div>
                        <div className="online-consultation">
                          <Link to={'/advice'}>
                            مشاوره آنلاین
                            <i className="icon-left-arrow"> </i>
                          </Link>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="newsletters">
                          <h6> خبرنامه </h6>
                          <p>
                            {' '}
                            از تخفیف‌ها و جدیدترین های بیمه‌با‌ما با خبر شوید:{' '}
                          </p>
                          <div className="newsletterBox">
                            <Input
                              label="آدرس ایمیل "
                              type="email"
                              margin="normal"
                              variant="outlined"
                              size="size"
                              fullWidth
                              value={email}
                              onChange={this.handleChangeInput('email')}
                            />
                            <Button
                              variant="contained"
                              color="default"
                              size="large"
                              fullWidth
                              onClick={this.handelEmail}
                            >
                              ثبت خبرنامه
                              <i className="icon-left-arrow" />
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="newsletters">
                          <h6> مشاوره تلفنی </h6>
                          <p>
                            {' '}
                            شماره تماس خود را وارد کنید، کارشناسان ما با شما
                            تماس خواهند گرفت{' '}
                          </p>
                          <div className="newsletterBox advice">
                            <Input
                              label="شماره تماس"
                              type="tel"
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              value={tel}
                              onChange={this.handleChangeInput('tel')}
                            />
                            <Button
                              variant="contained"
                              color="default"
                              size="large"
                              fullWidth
                              onClick={this.handelTel}
                            >
                              ثبت درخواست مشاوره
                              <i className="icon-left-arrow"> </i>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="social-address">
              <div className="container-fluid">
                <div className="row justify-content-between">
                  <div className="col-md-4">
                    <div className="secret-bama">
                      <div className="col-12 col-md-12 col-lg-5">
                        <div className="image-logo-bama">
                          <img src={logo} alt="" />
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="copy-right-bama">
                          <i className="icon-copyright"> </i>
                          <p> زمستان ۱۳۹۸ ، تهران، ایران </p>
                        </div>
                      </div>
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="text-secret">
                          {/* <p>
                          {' '}
                          کلیه حقوق این سامانه در اختیار سامانه بیمه‌باما
                          می‌باشد.{' '}
                        </p>
                        <p> هرگونه استفاده تجاری قابل تعقیب است. </p> */}
                          <p className="text-justify">
                            بیمه باما یک وبسایت مشاوره، مقایسه و خرید آنلاین
                            بیمه نامه است. شما می توانید از طریق گوشی موبایل یا
                            کامپیوتر خود به راحتی از این سامانه استفاده کنید. با
                            کمک بیمه باما و در کمترین زمان شما می توانید قیمت،
                            پوششهای بیمه نامه و سطح خدمات شرکتهای بیمه ی مختلف
                            را با یکدیگر مقایسه و بیمه نامه مورد نظر خود را
                            انتخاب و خریداری کنید.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <Typography className={classes.titleFooter}>
                      نمادهای اعتماد الکترونیکی
                    </Typography>
                    <div className="row">
                      <div className="col-md-4 col-6">
                        <div className={classes.eNamad}>
                          <a
                            referrerpolicy="origin"
                            target="_blank"
                            href="https://trustseal.enamad.ir/?id=447807&Code=5AIp1C73FJdIpB5BlESW7W2nTZFtP6K2"
                          >
                            <img
                              referrerpolicy="origin"
                              src="https://trustseal.enamad.ir/logo.aspx?id=447807&Code=5AIp1C73FJdIpB5BlESW7W2nTZFtP6K2"
                              alt=""
                              style={{
                                cursor: 'pointer',
                              }}
                              code="5AIp1C73FJdIpB5BlESW7W2nTZFtP6K2"
                            />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 col-6">
                        <div className={classes.eNamad}>
                          <img
                            id="jxlzfukzjzpeesgtjxlzsizp"
                            style={{ cursor: 'pointer' }}
                            onClick={this.handelClickSamandehi}
                            alt="logo-samandehi"
                            src="https://logo.samandehi.ir/logo.aspx?id=167019&p=nbpdwlbqyndtlymanbpdbsiy"
                          />
                        </div>
                      </div>
                      <div className="col-md-4 col-6">
                        <div className={classes.centralInsurance}>
                          <img
                            style={{ cursor: 'pointer' }}
                            onClick={this.handelClickCentralInsurance}
                            alt="logo-center"
                            src={centralInsuranceImage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <Typography className={classes.titleFooter}>
                      صفحات داخلی
                    </Typography>
                    <ul className={classes.footerMenu}>
                      <li>
                        <Link to={'/about-us'}>درباره ما</Link>
                      </li>
                      <li>
                        <Link to={'/contact-us'}>تماس با ما</Link>
                      </li>
                      <li>
                        <Link to={'/terms-and-conditions'}>
                          قوانین و مقررات
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-3">
                    <Typography className={classes.titleFooter}>
                      کجا ما را پیدا کنید!؟
                    </Typography>
                    <div className="social row justify-content-end">
                      <div className="col-md-12">
                        <div className="social-bama">
                          <ul>
                            <li>
                              <Link to={'/'}>
                                <i className="icon-map"> </i>
                              </Link>
                            </li>
                            <li>
                              <Link to={'/'}>
                                <i className="icon-twitter"> </i>
                              </Link>
                            </li>
                            <li>
                              <Link to={'/'}>
                                <i className="icon-instagram"> </i>
                              </Link>
                            </li>
                            <li>
                              <Link to={'/'}>
                                <i className="icon-telegram"> </i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="address-bama">
                          <p>
                            آدرس تهران - میرداماد- شمس تبریزی شمالی - پلاک ۶
                          </p>
                        </div>
                      </div>
                      <div className="col-md-12 col-6">
                        <div className="phone-bama">
                          <span> تلفن پشتیبانی: </span>
                          <span> 021-91005110 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </footer>
        </>
      )
    );
  }
}

export default styles(withRouter(Footer));
